export interface IPYTHON_DAG_CONF {
    url: string,
    component_name: string,
}

export const IPYTHON_DAG_FINAL_TASK_ID = "login_push_dockerhub"